import _asyncToGenerator from "/home/runner/work/integracao-custos/integracao-custos/frontend/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/integracao-custos/integracao-custos/frontend/app/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.regexp.replace.js";
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import 'quasar/dist/quasar.ie.polyfills.js';
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css';
import '@quasar/extras/roboto-font/roboto-font.css';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css';

// We load Quasar stylesheet file
import 'quasar/dist/quasar.sass';
import 'src/css/app.sass';
import Vue from 'vue';
import createApp from "./app.js";
import 'app/src-pwa/register-service-worker.js';
import qboot_Bootaxios from 'boot/axios';

// Needed only for iOS PWAs
if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && window.navigator.standalone) {
  import(/* webpackChunkName: "fastclick"  */'@quasar/fastclick');
}
function start() {
  return _start.apply(this, arguments);
}
function _start() {
  _start = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$createApp, app, store, router, routeUnchanged, redirect, urlPath, bootFiles, i, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return createApp();
        case 1:
          _yield$createApp = _context.sent;
          app = _yield$createApp.app;
          store = _yield$createApp.store;
          router = _yield$createApp.router;
          routeUnchanged = true;
          redirect = function redirect(url) {
            routeUnchanged = false;
            window.location.href = url;
          };
          urlPath = window.location.href.replace(window.location.origin, '');
          bootFiles = [qboot_Bootaxios];
          i = 0;
        case 2:
          if (!(routeUnchanged === true && i < bootFiles.length)) {
            _context.next = 8;
            break;
          }
          if (!(typeof bootFiles[i] !== 'function')) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("continue", 7);
        case 3:
          _context.prev = 3;
          _context.next = 4;
          return bootFiles[i]({
            app: app,
            router: router,
            store: store,
            Vue: Vue,
            ssrContext: null,
            redirect: redirect,
            urlPath: urlPath
          });
        case 4:
          _context.next = 7;
          break;
        case 5:
          _context.prev = 5;
          _t = _context["catch"](3);
          if (!(_t && _t.url)) {
            _context.next = 6;
            break;
          }
          window.location.href = _t.url;
          return _context.abrupt("return");
        case 6:
          console.error('[Quasar] boot error:', _t);
          return _context.abrupt("return");
        case 7:
          i++;
          _context.next = 2;
          break;
        case 8:
          if (!(routeUnchanged === false)) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return");
        case 9:
          new Vue(app);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 5]]);
  }));
  return _start.apply(this, arguments);
}
start();